// extracted by mini-css-extract-plugin
var _1 = "wHbFM33dBjFRn4dSpi_3";
export { _1 as "input" }
